import React from "react";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import BlueInfoTooltip from "visual-components/util/tooltip/BlueInfoTooltip";

/**
 * Display an empty chart card with a title and message
 * @param {Object} props
 * @param {string} props.title - Title to display in the card header
 * @param {string} props.message - Message to display in the empty state
 * @returns {import("react").ReactElement}
 */
export default function EmptyChartCard(props) {
  const { title, message } = props;

  return (
    <Card className="h-full !w-[660px]">
      <CardHeader
        title={
          <div className="flex items-center gap-2">
            <Typography color="primary" variant="h4">
              {title}
            </Typography>
            <BlueInfoTooltip text="Individual social action clicks by their specific titles" />
          </div>
        }
      />
      <CardContent>
        <div className="flex h-[300px] items-center justify-center">
          <Typography color="secondary" variant="h5">
            {message}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
